  import {
    Table,
    Input,
    InputNumber,
    Popconfirm,
    Form,
    Button,
    Typography,
  } from "antd";
  import Loader from "components/common/Loader";
  import {
    useFetchInventoryQuery,
    useUpdateInventoryMutation,
    useFetchInventoryFilterOptionsQuery,
  } from "features/store";
  import React, { useState } from "react";
  import EditableTable from "./EditableTable";
  import styled from "styled-components";
  import { TableTitleStyles } from "./Inventory.style";
  import { getColorHex, normalizeHexColor } from "../../utils/identifyColor";
  
  const Popcorn = ({ loading }) => {
    const { data: dataSource, isLoading } = useFetchInventoryQuery({
      cloth_type: "POPCORN",
    });

    // Fetch filter options from all data, not just paginated data
    const { data: filterOptions } = useFetchInventoryFilterOptionsQuery({
      cloth_type: "POPCORN",
    });

    // Use filter options from API (all data) instead of paginated data
    const uniqueColors = filterOptions?.colors?.length 
      ? filterOptions.colors.filter((it) => it !== null && it !== '')
      : [...new Set(dataSource?.map(item => item?.color_cloth?.color))].filter((it) => it !== null);
    const codeArry = filterOptions?.color_codes?.length
      ? filterOptions.color_codes.filter((it) => it !== null && it !== '')
      : [...new Set(dataSource?.map(item => item?.color_cloth?.color_code))].filter((it) => it !== null);
  
    // const {id, quantity, color_cloth} = dataSource
    // const {color	, cloth_type, type}=color_cloth
    const columns = [
      {
        title: "Sr. No.",
        dataIndex: "id",
      },
      {
        title: "Type",
        dataIndex: ["color_cloth", "cloth_type"],
      },
      {
        title: "Color Code",
        dataIndex: ["color_cloth", "color_code"],
        filters: codeArry.map(client => ({
          text: client,
          value: client,
        })),
        filterSearch: true,
        render: (text) => {
          const normalized = normalizeHexColor(text);
          return normalized || (text ? `#${String(text).toUpperCase()}` : "");
        },
      },
      {
        title: "Color",
        dataIndex: ["color_cloth", "color"],
        filters: uniqueColors.map(client => ({
          text: client,
          value: client,
        })),
        filterSearch: true,
        render: (text, record) => {
          const hexColor = getColorHex(record?.color_cloth || {});
          
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
              <span>{text}</span>
              {hexColor ? (
                <div
                  style={{
                    width: 24,
                    height: 24,
                    backgroundColor: hexColor,
                    border: hexColor.toLowerCase() === '#ffffff' || hexColor.toLowerCase() === '#fff' ? '1px solid #d9d9d9' : 'none',
                    borderRadius: 4,
                    flexShrink: 0,
                  }}
                />
              ) : (
                <div
                  style={{
                    width: 24,
                    height: 24,
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #d9d9d9',
                    borderRadius: 4,
                    flexShrink: 0,
                  }}
                />
              )}
            </div>
          );
        },
      },
      {
        title: "Last Updates",
        dataIndex: "last_updated_date",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        width: "15%",
        editable: true,
      },
    ];
    const inventory = "invetetetet";
    return (
    
        <div className="inventory-table">
          <TableTitleStyles>POPCORN</TableTitleStyles>
          <EditableTable
            inventory={inventory}
            loading={isLoading}
            dataSource={dataSource}
            columns={columns}
          />
          
        </div>
    
    );
  };
  
  export default Popcorn;
  
  const Style = styled.div`
  
  `;
  